import { Container, Title, Divider, Text, Card, Stack, SimpleGrid } from "@mantine/core";
import { ROADMAP } from "../roadmap";

export default function StatusPage() {
    const content = Object.entries(ROADMAP);

    return (
        <Container fluid>
            <Title>Status</Title>
            <Text size="md" c="dimmed" mb="xl">Planned Features & Known Issues</Text>
            <SimpleGrid cols={2}>
                {content.map(([key, value]) => (<Stack>
                    <Text size="1.2rem" fw={500}>{key}</Text>
                    <Divider />
                    {value.map((v, i) => (<Card key={`${key}-${i}`}>{v}</Card>))}
                </Stack>))}
            </SimpleGrid>
        </Container>
    );
}
